import React, { useRef, useState, useLayoutEffect } from "react";
import ReactTooltip from "react-tooltip";

export const TrimText = (value, size = 40) => {
  return value != undefined && value.length > size
    ? value.slice(0, size) + "..."
    : value;
};

export function DynamicTrimText({ text, showTooltip}) {
  const ref = useRef(null);
  const [trimmed, setTrimmed] = useState(text);
  const [needsEllipsis, setNeedsEllipsis] = useState(false);
  // measure() does the canvas+binary-search truncation
  const measure = () => {
    const el = ref.current;
    if (!el) return;
    const style = getComputedStyle(el);
    // build font string
    const font = [
      style.fontStyle,
      style.fontVariant,
      style.fontWeight,
      style.fontSize,
      style.fontFamily,
    ].join(" ");
    // reuse a hidden canvas
    const canvas =
      measure.canvas || (measure.canvas = document.createElement("canvas"));
    const ctx = canvas.getContext("2d");
    ctx.font = font;

    const avail = el.clientWidth;
    const ell = "…";
    const ellW = ctx.measureText(ell).width;
    const fullW = ctx.measureText(text).width;

    if (fullW <= avail) {
      setTrimmed(text);
      setNeedsEllipsis(false);
      return;
    }

    // binary-search max chars that fit
    let lo = 0,
      hi = text.length;
    while (lo < hi) {
      const mid = Math.ceil((lo + hi) / 2);
      if (ctx.measureText(text.slice(0, mid)).width + ellW <= avail) {
        lo = mid;
      } else {
        hi = mid - 1;
      }
    }
    setTrimmed(text.slice(0, lo));
    setNeedsEllipsis(true);
  };

  // initial & text-change measurement
  useLayoutEffect(measure, [text]);

  // observe container size changes
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [text]);

  return (
    <h2
      ref={ref}
      title={text}
      style={{
        margin: 0,
        flex: "1 1 0", // fill & shrink in flex parent
        minWidth: 0, // magic flex trick
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "clip", // hide native ...
      }}
    >
      {trimmed}
      {needsEllipsis && (

        <>
        <span
          title=""
          style={{ color: "var(--button-color)" }}
          data-tip={`<div style="display: flex; flex-direction: row; gap: 8px; justify-content: flex-start; align-items: center; align-content: center; padding: 5px 2px; font-size: 12px; font-weight: 600; color:#ffffff;"><span style="max-width: 225px; height: auto; text-wrap: auto;"><p> ${text} </p></span> </div>`}
          data-for="title-tooltip"
        >
          …
        </span>
        {showTooltip == "true" ? (
        <ReactTooltip html={true}  id='title-tooltip' backgroundColor="var(--button-color)" effect="solid" padding="4px" place="left"  class="title-tooltip-card" delayHide={200} delayShow={200} offset={{bottom: 8, left:2 }} />
       )  : null }     
       </>
      )}

    </h2>
  );
}
